import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { useGetProductsBySku } from '../../utils/use-get-products-by-sku.js';
import { CommerceToolsProductBlock } from './CommerceTools.js';

const ProductBlocksContainer = ({ skus =[] , limit , className , reimbursableLogos  })=>{
    const { products , isLoading  } = useGetProductsBySku(skus, limit);
    const classNames = classnames('product-blocks-container', {
        className,
        loading: isLoading
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, isLoading ? /*#__PURE__*/ React.createElement(Loader, null) : products.map((product)=>/*#__PURE__*/ React.createElement(CommerceToolsProductBlock, {
            key: product.id,
            product: product,
            reimbursableLogos: reimbursableLogos
        })
    ));
};
var ProductBlocksContainer$1 = ProductBlocksContainer;

export { ProductBlocksContainer, ProductBlocksContainer$1 as default };
//# sourceMappingURL=ProductBlocksContainer.js.map
